import { render, staticRenderFns } from "./WalletHistoryTable.vue?vue&type=template&id=7298751b&scoped=true"
import script from "./WalletHistoryTable.vue?vue&type=script&lang=js"
export * from "./WalletHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./WalletHistoryTable.vue?vue&type=style&index=0&id=7298751b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7298751b",
  null
  
)

/* custom blocks */
import block0 from "./WalletHistoryTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports